// AmenitiesGrid — 12-icon amenities grid using lucide-react icons.
// Used in HotelDetailPage Overview tab.

import {
  Wifi, Waves, Sparkles, Coffee, Dumbbell, Car,
  UtensilsCrossed, Wine, Clock, Wind, ShieldCheck, ConciergeBell,
  type LucideIcon,
} from 'lucide-react';

const T = {
  surface: '#FFFFFF', ink: '#1A0F08',
  primary: '#FF5A3C', line: 'rgba(26,15,8,0.08)',
  sans: '"Inter Variable","Inter",system-ui,sans-serif',
};

const ICON_MAP: Record<string, LucideIcon> = {
  wifi:            Wifi,
  waves:           Waves,
  sparkles:        Sparkles,
  coffee:          Coffee,
  dumbbell:        Dumbbell,
  car:             Car,
  utensils:        UtensilsCrossed,
  cocktail:        Wine,
  clock:           Clock,
  wind:            Wind,
  shield:          ShieldCheck,
  'concierge-bell': ConciergeBell,
};

export interface Amenity {
  icon: string;
  label: string;
}

interface AmenitiesGridProps {
  amenities: Amenity[];
  columns?: 2 | 3 | 4;
}

export function AmenitiesGrid({ amenities, columns = 3 }: AmenitiesGridProps) {
  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: `repeat(${columns}, 1fr)`,
      gap: 8,
    }}>
      {amenities.map(a => {
        const Icon = ICON_MAP[a.icon] ?? Sparkles;
        return (
          <div
            key={a.label}
            style={{
              display: 'flex', alignItems: 'center', gap: 10,
              padding: '12px 14px', borderRadius: 18,
              background: T.surface, border: `1px solid ${T.line}`,
            }}
          >
            <Icon size={18} stroke={T.primary} strokeWidth={1.8}/>
            <span style={{
              fontFamily: T.sans, fontSize: 13, fontWeight: 500, color: T.ink,
            }}>{a.label}</span>
          </div>
        );
      })}
    </div>
  );
}
